// import { id } from 'element-plus/es/locale/index.js';
import { http } from "./http.js";
//获取分类
export const getclass = (data) => {
  return http({
    url: "/api/index/getcat",
    method: "post",
    data,
  });
};
//获取首页数据
export const getbanner = (data) => {
  return http({
    url: "/api/index/index",
    method: "post",
    data,
  });
};
//获取公司简介
export const getcompany = (data) => {
  return http({
    url: "/api/index/list?catid=2",
    method: "post",
    data,
  });
};
//获取新闻中心
export const getnews = (data) => {
  return http({
    url: "/api/index/list?catid=4",
    method: "post",
    data,
  });
};
//获取最新动态
export const getnews1 = (data) => {
  return http({
    url: "/api/index/list?catid=6",
    method: "post",
    data,
  });
};
//获取通知公告
export const getnews2 = (data) => {
  return http({
    url: "/api/index/list?catid=5",
    method: "post",
    data,
  });
};

//获取内容
export const getList = (e) => {
  return http({
    url: "/api/index/list?catid=" + e,
    method: "post",
  });
}
//获取内容详情
export const getCnt = (e) => {
  return http({
    url: "/api/index/getdetail?id=" + e,
    method: "get",
  });
}
//获取分页
export const getPage = (data) => {
  return http({
    url: "/api/index/list",
    method: "get",
    params: data,
  })
}
//切换主题颜色
export const getColor = (data) => {
  return http({
    url: "/api/index/getcolor",
    method: "get",
    params: data,
  })
}
//友情链接
export const getLink = (data) => {
  return http({
    url: "/api/index/getlink",
    method: "get",
    params: data,
  })
}
//开关网页
export const getclose = (data) => {
  return http({
    url: "/api/index/isclose",
    method: "get",
    params: data,
  })
}
//获取公司详情
export const getcompanyinfo = (data) => {
  return http({
    url: "/api/index/getcompanyinfo",
    method: "get",
    params: data,
  })
}
//获取图片
export const getphoto = (data) => {
  return http({
    url: "/api/index/getad",
    method: "get",
    params: data,
  })
}
//关键词搜所
export const getSheach = (e,w) => {
  return http({
    url: "/api/index/list?keyword=" + e + '&catid=' + w,
    method: "get",
  })
}
//初始化
export const getinit = () => {
  return http({
    url: "/api/common/init?version=1.2.9",
    method: "get",
  })
}